import React, { useEffect, useState, Fragment } from "react";
import ActionButton from "../general/ActionButton";
import { useDispatch } from "react-redux";
import {
  getBrokerageInformation,
  updateDetails,
  getDetailsAdmin,
  getIsUpdating,
  getUpdateErrors,
  getAddressStatus,
  toggleAddressModal,
  addBranch,
  deleteBranch,
} from "../store/brokerage";
import { getProvinceInformation } from "../store/broker";
import { useSelector } from "react-redux";
import DeleteOutlineOutlinedIcon from "@material-ui/icons/DeleteOutlineOutlined";
import EditIconOutlined from "@material-ui/icons/CreateOutlined";
import PerfectScrollbar from "react-perfect-scrollbar";
import Modal from "react-modal";
import * as theme from "../theme";
import { toast } from "react-toastify";
import Spinner from "react-bootstrap/Spinner";
import Button from "react-bootstrap/Button";
import {
  getBrokeragesList,
  loadBrokerages,
  brokerageSelected,
  updateSubscription,
  getSubscribeUpdate,
  updateSubscriptionDetails,
} from "../store/brokerages";
import Select from "react-dropdown-select";
import { useNavigate } from "react-router-dom";
import { values } from "lodash";

const BrokerageSuperAdminDetails = (props) => {
  const dispatch = useDispatch();

  let navigate = useNavigate();
  const [selectedCode, setSelectedCode] = useState(null);
  const brokerages = useSelector(getBrokeragesList);
  const [selectedBrokerageName, setSelectedBrokerageName] = useState(
    "Search for a brokerage"
  );

  useEffect(() => {
    dispatch(loadBrokerages());
    if (props.brokerageCode) {
      dispatch(getDetailsAdmin(props.brokerageCode));
      setSelectedCode(props.brokerageCode);
    }
  }, [dispatch]);

  useEffect(() => {
    if (
      !props.brokerageCode &&
      !selectedCode &&
      brokerages &&
      brokerages[0]?.code
    ) {
      dispatch(getDetailsAdmin(brokerages[0].code));
      setSelectedBrokerageName(brokerages[0].name);
      setSelectedCode(brokerages[0].code);
    } else if (props.brokerageCode && brokerages) {
      for (let br of brokerages) {
        if (br.code == props.brokerageCode) {
          //dispatch(getDetailsAdmin(br.code));
          setSelectedBrokerageName(br.name);
          //setSelectedCode(br.code);
          break;
        }
      }
    }
  }, [brokerages]);

  const onChangeHandle = (value) => {
    if (value[0]?.code) {
      navigate(
        "/quoteyadmin/details?c=" + encodeURIComponent(value[0].code)
      );
      dispatch(getDetailsAdmin(value[0].code));
      setSelectedCode(value[0].code);
      setSelectedBrokerageName(value[0].name);
    }
  };

  return (
    <div>
      <div
        style={{
          width: "100%",
        }}
      >
        <div style={{ width: "80%", marginLeft: "10%", marginTop: "20px" }}>
          <Select
            placeholder={selectedBrokerageName}
            color={theme.COLORS.primary_navyblue}
            searchable={true}
            onChange={(values) => onChangeHandle(values)}
            values={[]}
            options={brokerages}
            style={{
              width: "100%",
              height: "6vh",
              fontSize: "1.9vmin",
              border: "5px solid white",
              borderRadius: 15,
              fontFamily: "GibsonRegular",
            }}
            labelField={"name"}
            valueField={"code"}
            dropdownHeight={"58vh"}
          />
        </div>
      </div>
      <BrokerageDetailsPane brokerageCode={selectedCode} />
    </div>
  );
};

const BrokerageDetailsPane = (props) => {
  return (
    <div
      style={{
        margin: "3.5rem",
        marginTop: "1.5rem",
        // marginBottom: "14rem",
      }}
    >
      <h5
        className="px-2"
        style={{
          fontFamily: "GibsonSemiBd",
          justifyContent: "center",
          fontSize: "1.2vw",
        }}
      >
        Your brokerage name and contact details will appear on various pieces of
        documentation. Please ensure they are accurate and update as necessary.
      </h5>
      <BrokerageDetailItems
        key={new Date().getTime()}
        brokerageCode={props.brokerageCode}
      />
    </div>
  );
};

const BrokerageDetailItems = (props) => {
  const [select, setSelect] = useState("");
  const [provinceValue, setProvinceValue] = useState([]);
  const [name, setName] = useState(null);
  const [addr1, setAddr1] = useState(null);
  const [addr2, setAddr2] = useState(null);
  const [city, setCity] = useState(null);
  const [province, setProvince] = useState(null);
  const [postalcode, setPostalCode] = useState(null);
  const [website, setWebsite] = useState(null);
  const [phone, setPhone] = useState(null);

  const dispatch = useDispatch();
  const onAddAddressClickHandle = (value) => {
    dispatch(toggleAddressModal(value));
  };
  const information = useSelector(getBrokerageInformation);
  const provinces = useSelector(getProvinceInformation);
  const [brokerInformation, setBrokerInformation] = useState(information);
  const subscribeUpdate = useSelector(getSubscribeUpdate);
  useEffect(() => {
    if (subscribeUpdate.brokerage) {
      setBrokerInformation(subscribeUpdate.brokerage);
    }
  }, [subscribeUpdate]);

  let addressModalState = useSelector(getAddressStatus);
  let isUpdating = useSelector(getIsUpdating);
  let updateErrors = useSelector(getUpdateErrors);
  useEffect(() => {
    if (provinces) {
      setProvinceValue(provinces.provinces);
    }
  }, [provinces]);
  useEffect(() => {
    if (information) setBrokerInformation(information);
  }, [information]);
  useEffect(() => {
    if (brokerInformation?.address != undefined && brokerInformation.address) {
      let name = provinces?.provinces.filter((prv) => {
        if (
          prv.code == brokerInformation.address?.map((t) => t.province)[0] ||
          brokerInformation.address?.map((t) => t.province) == prv.name
        ) {
          setSelect(prv.name);
        }
      });
    }
  }, [brokerInformation?.address]);

  const code = brokerInformation.code;
  const onProvinceHandle = (value) => {
    setProvince(value[0].code);
  };
  const handleSubscriptionUpdate = () => {
    const data = {
      code: code,
      is_active_subscription:
        brokerInformation?.is_active_subscription === true ? false : true,
    };
    dispatch(updateSubscription(data)).then(() => {
      toast.success(subscribeUpdate.message);
    });
  };
  return (
    <div style={{ fontFamily: "GibsonRegular", fontSize: "0.8vw" }}>
      <form className="m-4">
        <div className="form-group row">
          <label className="col-sm-2 col-form-label">Brokerage Name</label>
          <div className="col-sm-10">
            <input
              className="form-control"
              id="txtName"
              placeholder="Enter Brokerage name"
              onChange={(event) => {
                setName(event.target.value);
              }}
              defaultValue={brokerInformation.name}
            />
          </div>
        </div>
        <div className="form-group row">
          <label className="col-sm-2 col-form-label">Primary Address</label>
          <div className="col-sm-10">
            <input
              className="form-control my-2"
              id="txtAdd1"
              placeholder="Enter Brokerage Address 1"
              onChange={(event) => {
                setAddr1(event.target.value);
              }}
              defaultValue={
                brokerInformation.address
                  ? brokerInformation.address[0].addr_line1
                  : ""
              }
            />
            <input
              className="form-control my-2"
              id="txtAdd2"
              placeholder="Enter Brokerage Address 2"
              onChange={(event) => {
                setAddr2(event.target.value);
              }}
              defaultValue={
                brokerInformation.address
                  ? brokerInformation.address[0].addr_line2
                  : ""
              }
            />
            <input
              className="form-control my-2"
              id="txtCity"
              placeholder="Enter Brokerage City"
              onChange={(event) => {
                setCity(event.target.value);
              }}
              defaultValue={
                brokerInformation.address
                  ? brokerInformation.address[0].city
                  : ""
              }
            />
            <Select
              placeholder={select}
              color={theme.COLORS.primary_navyblue}
              searchable={true}
              onChange={(values) => onProvinceHandle(values)}
              values={[]}
              options={provinceValue}
              style={{
                width: "100%",
                height: "5vh",
                fontSize: "1.9vmin",
                border: "5px solid white",
                borderRadius: 15,
                fontFamily: "GibsonRegular",
              }}
              labelField={"name"}
              valueField={"code"}
              dropdownHeight={"58vh"}
            />
            <input
              className="form-control my-2"
              id="txtPostalCode"
              placeholder="Enter Brokerage Postal Code"
              onChange={(event) => {
                setPostalCode(event.target.value);
              }}
              defaultValue={
                brokerInformation.address
                  ? brokerInformation.address[0].postal_code
                  : ""
              }
            />
            <div style={{ width: "20%", float: "right" }}>
              <Button
                style={{
                  color: "white",
                  height: "3.5vh",
                  fontFamily: "GibsonSemiBd",
                  fontSize: 12,
                  backgroundColor: theme.COLORS.secondary_skyblue,
                  marginTop: 5,
                  marginLeft: 10,
                  border: 0,
                  width: "9vw",
                  letterSpacing: 1,
                }}
                onClick={() => {
                  onAddAddressClickHandle(true);
                }}
              >
                Add Another Branch
              </Button>
            </div>
          </div>
        </div>
        <div className="form-group row">
          <label className="col-sm-2 col-form-label">Additional Branches</label>
          <div className="col-sm-10">
            <table className="table table-sm">
              <thead>
                <tr>
                  <th scope="col">Address 1</th>
                  <th scope="col">Address 2</th>
                  <th scope="col">City</th>
                  <th scope="col">Province</th>
                  <th scope="col">Postal Code</th>
                  {/* <th scope="col"></th> */}
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                {brokerInformation.address ? (
                  brokerInformation.address.slice(1).map((item, i) => {
                    return (
                      <Fragment key={i}>
                        <tr scope="row">
                          <td> {item.addr_line1} </td>
                          <td> {item.addr_line2} </td>
                          <td> {item.city} </td>
                          <td> {item.province} </td>
                          <td style={{ width: "150px" }}>
                            {item.postal_code}
                          </td>
                          <td style={{ width: "150px" }}>{item.postal_code}</td>
                          <td
                            className="text-center bg-danger"
                            style={{
                              width: "50px",
                              padding: 5,
                              borderRadius: 20,
                              color: "white",
                            }}
                          >
                            <DeleteOutlineOutlinedIcon
                              onClick={() => {
                                let data = {
                                  brokerage_code: code,
                                  addr_line1: item.addr_line1,
                                  addr_line2: item.addr_line2,
                                  city: item.city,
                                  province: item.province,
                                  postal_code: item.postal_code,
                                };
                                dispatch(deleteBranch(data)).then(
                                  setTimeout(() => {
                                    dispatch(getDetailsAdmin(code));
                                    Array.isArray(updateErrors) &&
                                    !updateErrors.length
                                      ? toast.success(
                                          "Branch Deletion Successful"
                                        )
                                      : toast(updateErrors);
                                  }, 100)
                                );
                              }}
                            />
                          </td>
                        </tr>
                      </Fragment>
                    );
                  })
                ) : (
                  <tr key={"0"}>
                    <td colSpan="6"></td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        <div className="form-group row">
          <label className="col-sm-2 col-form-label">Website</label>
          <div className="col-sm-10">
            <input
              className="form-control"
              id="txtWebsite"
              placeholder="Enter Brokerage Website"
              onChange={(event) => {
                setWebsite(event.target.value);
              }}
              defaultValue={brokerInformation.website}
            />
          </div>
        </div>
        <div className="form-group row">
          <label className="col-sm-2 col-form-label">Contact Number</label>
          <div className="col-sm-10">
            <input
              className="form-control"
              id="txtPhone"
              placeholder="Enter Contact Number"
              onChange={(event) => {
                setPhone(event.target.value);
              }}
              defaultValue={brokerInformation.contact_number}
            />
          </div>
        </div>
        {brokerInformation?.subscription_id != null && (
          <div style={{ width: "30%", float: "left" }}>
            <Button
              style={{
                color: "white",
                height: "4vh",
                fontFamily: "GibsonSemiBd",
                fontSize: 13,
                backgroundColor: theme.COLORS.secondary_skyblue,
                marginTop: 8,
                border: 0,
                width: "10vw",
                letterSpacing: 1,
              }}
              onClick={handleSubscriptionUpdate}
            >
              {brokerInformation?.is_active_subscription
                ? "Stop Payment"
                : "Resume Payment"}
            </Button>
          </div>
        )}
        <div style={{ width: "10%", float: "right" }}>
          <Button
            style={{
              color: "white",
              height: "3.5vh",
              fontFamily: "GibsonSemiBd",
              fontSize: 12,
              backgroundColor: theme.COLORS.secondary_skyblue,
              marginTop: 5,
              marginLeft: 10,
              border: 0,
              width: "5vw",
              letterSpacing: 1,
            }}
            onClick={() => {
              let data = {
                brokerage_code: code,
                brokerage_name: name,
                contact_number: phone,
                website: website,
                addr1: addr1,
                addr2: addr2,
                city: city,
                province: province,
                postal_code: postalcode,
              };
              dispatch(updateDetails(data)).then(
                setTimeout(() => {
                  if (Array.isArray(updateErrors) && !updateErrors.length) {
                    toast.success("Updated Successfully");
                    return (
                      <BrokerageDetailItems
                        key={new Date().getTime()}
                        brokerageCode={code}
                      />
                    );
                  } else toast(updateErrors);
                }, 100)
              );
            }}
          >
            {isUpdating ? (
              <Spinner animation="border" size="sm" variant="light" />
            ) : (
              "Save"
            )}
          </Button>
        </div>
      </form>

      <Modal
        size="md"
        isOpen={addressModalState}
        ariaHideApp={false}
        shouldCloseOnEsc={false}
        centered
        style={{
          overlay: {
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: theme.COLORS.rgba_primary_navyblue,
          },
          justifyContent: "center",
          content: {
            height: "50vh",
            width: "50vw",
            position: "absolute",
            top: "15vh",
            left: "25vw",
            background: "#eef3f6",
            WebkitOverflowScrolling: "touch",
            border: "8px solid " + theme.COLORS.primary_navyblue,
            borderRadius: "20px",
            padding: 0,
            overflow: "hidden",
          },
        }}
      >
        <AddressBox code={code} />
      </Modal>
    </div>
  );
};

const AddressBox = (props) => {
  const provinces = useSelector(getProvinceInformation);
  const code = props.code;
  const [provinceValue, setProvinceValue] = useState([]);
  const [addr1, setAddr1] = useState(null);
  const [addr2, setAddr2] = useState(null);
  const [city, setCity] = useState(null);
  const [province, setProvince] = useState([]);
  const [postalcode, setPostalCode] = useState(null);
  const isUpdating = useSelector(getIsUpdating);
  const updateErrors = useSelector(getUpdateErrors);
  const dispatch = useDispatch();
  const onProvinceHandle = (value) => {
    setProvince(value[0].code);
  };
  useEffect(() => {
    if (provinces) {
      setProvinceValue(provinces.provinces);
    }
  }, [provinces]);
  const onAddButtonClick = () => {
    let data = {
      brokerage_code: code,
      addr_line1: addr1,
      addr_line2: addr2,
      city: city,
      province: province,
      postal_code: postalcode,
    };
    dispatch(addBranch(data)).then(
      setTimeout(() => {
        dispatch(getDetailsAdmin(code));
        Array.isArray(updateErrors) && !updateErrors.length
          ? toast.success("Branch Added Successfully")
          : toast(updateErrors);
      }, 100)
    );
    dispatch(toggleAddressModal(false));
  };

  const onCancelButtonClick = (value) => {
    dispatch(toggleAddressModal(value));
  };

  return (
    <PerfectScrollbar>
      <div>
        <form className="m-4">
          <h3
            className="text-center m-3"
            style={{
              fontFamily: "GibsonSemiBd",
              justifyContent: "center",
              fontSize: "1.2vw",
            }}
          >
            Enter Address Details
          </h3>
          <div
            className="form-group row"
            style={{
              fontFamily: "GibsonRegular",
              justifyContent: "center",
              fontSize: "1vw",
            }}
          >
            <label className="col-sm-2 col-form-label">Address 1</label>
            <div className="col-sm-10">
              <input
                className="form-control"
                id="txtAddress1"
                placeholder="Enter Address Line 1"
                onChange={(event) => {
                  setAddr1(event.target.value);
                }}
                defaultValue={props.addr1}
              />
            </div>
          </div>
          <div
            className="form-group row"
            style={{
              fontFamily: "GibsonRegular",
              justifyContent: "center",
              fontSize: "1vw",
            }}
          >
            <label className="col-sm-2 col-form-label">Address 2</label>
            <div className="col-sm-10">
              <input
                className="form-control"
                id="txtAddress2"
                placeholder="Enter Address Line 2"
                onChange={(event) => {
                  setAddr2(event.target.value);
                }}
                defaultValue={props.addr2}
              />
            </div>
          </div>
          <div
            className="form-group row"
            style={{
              fontFamily: "GibsonRegular",
              justifyContent: "center",
              fontSize: "1vw",
            }}
          >
            <label className="col-sm-2 col-form-label">City</label>
            <div className="col-sm-10">
              <input
                className="form-control"
                id="txtCity"
                placeholder="Enter City"
                onChange={(event) => {
                  setCity(event.target.value);
                }}
                defaultValue={props.city}
              />
            </div>
          </div>
          <div
            className="form-group row"
            style={{
              fontFamily: "GibsonRegular",
              justifyContent: "center",
              fontSize: "1vw",
            }}
          >
            <label className="col-sm-2 col-form-label">Province</label>
            <div className="col-sm-10">
              <Select
                placeholder={"select province"}
                color={theme.COLORS.primary_navyblue}
                searchable={true}
                onChange={(values) => onProvinceHandle(values)}
                values={[]}
                options={provinceValue}
                style={{
                  width: "100%",
                  height: "5vh",
                  fontSize: "1.9vmin",
                  border: "5px solid white",
                  borderRadius: 15,
                  fontFamily: "GibsonRegular",
                }}
                labelField={"name"}
                valueField={"code"}
                dropdownHeight={"58vh"}
              />
            </div>
          </div>
          <div
            className="form-group row"
            style={{
              fontFamily: "GibsonRegular",
              justifyContent: "center",
              fontSize: "1vw",
            }}
          >
            <label className="col-sm-2 col-form-label">Postal Code</label>
            <div className="col-sm-10">
              <input
                className="form-control"
                id="txtPostalCode"
                placeholder="Enter Postal Code"
                onChange={(event) => {
                  setPostalCode(event.target.value);
                }}
                defaultValue={props.postalcode}
              />
            </div>
          </div>
          <div className="m-2" style={{ width: "10%", float: "right" }}>
            <Button
              style={{
                color: "white",
                height: "3.5vh",
                fontFamily: "GibsonSemiBd",
                fontSize: 12,
                backgroundColor: theme.COLORS.secondary_skyblue,
                marginTop: 5,
                marginLeft: 10,
                border: 0,
                width: "5vw",
                letterSpacing: 1,
              }}
              onClick={() => {
                onAddButtonClick();
              }}
            >
              {isUpdating ? (
                <Spinner animation="border" size="sm" variant="light" />
              ) : (
                "Add"
              )}
            </Button>
          </div>
          <div className="m-2" style={{ width: "10%", float: "right" }}>
            <Button
              style={{
                color: "white",
                height: "3.5vh",
                fontFamily: "GibsonSemiBd",
                fontSize: 12,
                backgroundColor: theme.COLORS.secondary_skyblue,
                marginTop: 5,
                marginLeft: 10,
                border: 0,
                width: "5vw",
                letterSpacing: 1,
              }}
              onClick={() => {
                onCancelButtonClick(false);
              }}
            >
              Cancel
            </Button>
          </div>
        </form>
      </div>
    </PerfectScrollbar>
  );
};

export default BrokerageSuperAdminDetails;
